import {useEffect} from "react";
import {
    clearCheckOrderData,
    setActiveTicket,
    setCheckOrderData,
    setIsCheckOrder
} from "@CheckOrder/reducers/checkOrderSlice";
import {useAppSelector} from "@Hooks/selector/useAppSelector";
import {useAppDispatch} from "@Hooks/dispatch/useAppDispatch";
import {useParams} from "react-router";
import {useLazyGetCheckOrderDataQuery} from "@CheckOrder/api/checkOrderApi";

export default function useGetCheckOrderData() {
    const {
        activeTicket,
        ticket,
        checkOrderRouteUrl,
        stripeClientSecret,
        stripePublicApiKey,
        stripeEnabled,
    } = useAppSelector((state) => state.checkOrder)

    // const currency = useCurrency()
    // const {prepareIntermodalRoute} = usePrepareIntermodalRoute()
    const dispatch = useAppDispatch()
    const userPassenger = useAppSelector((state) => state?.checkOrder.passengers[0])
    const [getCheckOrderData] = useLazyGetCheckOrderDataQuery()

    const params = useParams()

    const fetchTicketIfNoneExists = () => {
        if (!ticket) {
            getCheckOrderData({firstUser: userPassenger})
        }
    }

    useEffect(fetchTicketIfNoneExists, [])

    const handleUnloadEvent = () => (() => {
        if (activeTicket) {
            localStorage.removeItem('activeTicket')
            dispatch(setActiveTicket(null))
        }
    })

    const checkForExistingCheckOrderSession = () => {
        const activeTicket = localStorage.getItem('activeTicket')
        if (activeTicket) {
            dispatch(setActiveTicket(activeTicket))
        } else {
            localStorage.setItem('activeTicket', window.location.href)
        }
    }

    const fetchSessionData = () => {
        const ticketCode = ticket?.ticketCode ?? params?.ticketCode
        const sessionCheckOrderData = JSON.parse(sessionStorage.getItem(ticketCode))
        if (sessionCheckOrderData) {
            dispatch(setCheckOrderData(sessionCheckOrderData))
        }
    }

    useEffect(() => {
        dispatch(setIsCheckOrder(true))
        fetchSessionData()
        checkForExistingCheckOrderSession()
        window.scrollTo(0, 0)
        // Mark that we're on check-order page for detecting back navigation to search results
        sessionStorage.setItem('isOnCheckOrder', 'true')

        window.addEventListener('beforeunload', () => {
            handleUnloadEvent()
            sessionStorage.setItem('unloadEventOccurred', checkOrderRouteUrl)
        })

        return () => {
            dispatch(clearCheckOrderData())
            handleUnloadEvent()
            window.removeEventListener('beforeunload', handleUnloadEvent())
        }
    }, [])

    return {
        activeTicket,
        ticket,
        checkOrderRouteUrl,
        stripeClientSecret,
        stripePublicApiKey,
        stripeEnabled,
    }
}